interface CtaSectionProps {
  title: string;
  subtitle: string;
  buttonText: string;
  buttonIcon?: string;
  onButtonClick?: () => void;
  id?: string;
}

export default function CtaSection({ title, subtitle, buttonText, buttonIcon = 'ri-download-2-line', id }: CtaSectionProps) {
  const handleClick = () => {
    const el = document.getElementById('download');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id={id} className="w-full py-16 md:py-20 px-4 md:px-6">
      <div className="max-w-2xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-4xl text-foreground-50 mb-4 tracking-wider">
          {title}
        </h2>
        <p className="text-foreground-400 text-sm md:text-base mb-8">
          {subtitle}
        </p>
        <button
          onClick={handleClick}
          className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-950 font-medium text-sm rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
        >
          <span>{buttonText}</span>
          <i className={`${buttonIcon} w-4 h-4 flex items-center justify-center`}></i>
        </button>
      </div>
    </section>
  );
}